import React, { useEffect, useState } from "react";
import Header from "../../../Components/Header/Header";
import Footer from "../../../Components/Footer/Footer";
import "../AccountInformation/AccountInformation.css";
import { BiSolidPencil } from "react-icons/bi";
import { FaUserCircle } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoMdHome } from "react-icons/io";
import { FaCity } from "react-icons/fa";
import { FaLocationPin } from "react-icons/fa6";
import { BiWorld } from "react-icons/bi";
import { FaBuilding } from "react-icons/fa";

import {
  APIUrl,
  APIUrlToken,
  getIsAdmin,
  getIsUser,
  SetlocalStorage,
} from "../../../Utils/Utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader/Loader";
import AthleteUserRole from "./AthleteUserRole";

const AccountInformation = () => {
  const userLoginDetails = getIsUser();
  const adminStatus = localStorage.getItem("user_role");
  const [isError, setIsError] = useState(false);
  const [disableEdit, setDisableEdit] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    address: "",
    city: "",
    state: "",
    country: "",
    company_name: "",
    zipcode: "",
  });

  const handleEditClick = () => {
    setDisableEdit("edit");
  };
  const handleAdminDash = () => {
    navigate("/AdminDashboard");
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const getProfileInfo = () => {
    const url = `${APIUrl()}/v1/user-profiles/${userLoginDetails?.user_id}`;
    const option = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        let data = response?.data;
        setFormData({
          firstname: data?.first_name,
          lastname: data?.last_name,
          phoneno: data?.phone_number,
          address: data?.address,
          city: data?.city,
          state: data?.state,
          country: data?.country,
          company_name: data?.company_name,
          zipcode: data?.zipcode,
        });
        setIsError(false);
      })
      .catch((error) => {
        if (error?.response?.data?.detail === "User profile not found.") {
          setIsError(true);
        }
        console.error("Error fetching teams data:", error);
      });
  };
  useEffect(() => {
    getProfileInfo();
  }, []);

  const addUserProfileDetails = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/add_user_profile_details`;

    let data = {};
    data.user_id = userLoginDetails?.user_id;
    if (formData?.firstname) {
      data.first_name = formData.firstname;
    }
    if (formData?.lastname) {
      data.last_name = formData.lastname;
    }
    if (formData?.phoneno) {
      data.phone_number = formData.phoneno;
    }
    if (formData?.address) {
      data.address = formData.address;
    }
    if (formData?.city) {
      data.city = formData.city;
    }
    if (formData?.state) {
      data.state = formData.state;
    }
    if (formData?.country) {
      data.country = formData.country;
    }
    if (formData?.company_name) {
      data.company_name = formData.company_name;
    }
    if (formData?.zipcode) {
      data.zipcode = formData.zipcode;
    }
    axios
      .post(url, data, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        getProfileInfo();
        setDisableEdit("");
        setFormData({
          firstname: "",
          lastname: "",
          phoneno: "",
          address: "",
          city: "",
          state: "",
          country: "",
          company_name: "",
          zipcode: "",
        });
        toast.success("User Profile added successfully.");
        navigate("/");
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };

  const updateUserProfileDetails = () => {
    setLoading(true);
    const url = `${APIUrl()}/v1/user-profiles/${userLoginDetails?.user_id}`;

    let data = {};
    if (formData?.firstname) {
      data.first_name = formData.firstname;
    }
    if (formData?.lastname) {
      data.last_name = formData.lastname;
    }
    if (formData?.phoneno) {
      data.phone_number = formData.phoneno;
    }
    if (formData?.address) {
      data.address = formData.address;
    }
    if (formData?.city) {
      data.city = formData.city;
    }
    if (formData?.state) {
      data.state = formData.state;
    }
    if (formData?.country) {
      data.country = formData.country;
    }
    if (formData?.company_name) {
      data.company_name = formData.company_name;
    }
    if (formData?.zipcode) {
      data.zipcode = formData.zipcode;
    }

    axios
      .put(url, data, {
        headers: {
          "X-API-Key": APIUrlToken(),
        },
      })
      .then((response) => {
        setLoading(false);
        getProfileInfo();
        setDisableEdit("");
        setFormData({
          firstname: "",
          lastname: "",
          phoneno: "",
          address: "",
          city: "",
          state: "",
          country: "",
          company_name: "",
          zipcode: "",
        });
        toast.success("User Profile updated successfully.");
        SetlocalStorage("nilUser", {
          ...userLoginDetails,
          given_name: formData?.firstname,
        });

        navigate("/");
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching teams data:", error);
      });
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <Header />
      <div className="page-main-container-aboutus">
        <div className="content-section-accountInfo">
          <h3>
            {adminStatus === "athlete"
              ? "My Athelete Profile"
              : "My User Profile"}
          </h3>

          <div className="profile-container-accountInfo">
            <div className="profile-card-accountInfo">
              <div className="profile-header-accountInfo">
                {/* {adminStatus === "admin" ? <button className='edit-button-accountInfo' type='reset' onClick={handleAdminDash}>
                                    <FaUser /> Admin Dashboard
                                </button> : null}
                                {adminStatus === "athlete" && (
                                    <button className='edit-button-accountInfo' type='reset' onClick={() => navigate("/AthleteDashboard")}>
                                        <FaUser /> Athlete Dashboard
                                    </button>
                                    )} */}
                {adminStatus === "admin" && (
                  <button
                    className="edit-button-accountInfo"
                    type="reset"
                    onClick={() => navigate("/AdminDashboard")}
                  >
                    <FaUser /> Admin Dashboard
                  </button>
                )}
                {/* 
                {adminStatus === "athlete" && (
                  <button
                    className="edit-button-accountInfo"
                    type="reset"
                    onClick={() => navigate("/AthleteDashboard")}
                  >
                    <FaUser /> Athlete Dashboard
                  </button>
                )} */}

                {adminStatus === "athlete" ? (
                  ""
                ) : isError ?  null : (
                  <button
                    // className="edit-button-accountInfo"
                     className={
              disableEdit
                ? "edit-button-accountInfo-active"
                : "edit-button-accountInfo"
            }
                    type="reset"
                    onClick={handleEditClick}
                  >
                    <BiSolidPencil /> {adminStatus === "athlete"
              ? "Edit Athlete Profile" : "Edit User Profile"}
                  </button>
                )}
              </div>
              {adminStatus === "athlete" ? (
                <AthleteUserRole />
              ) 
              : isError && disableEdit === "" ? (
                <div className="ai_no_profile">
                  <button
                    className="edit-button-accountInfo"
                    onClick={() => {
                      setDisableEdit("add");
                    }}
                  >
                    Please create your profile
                  </button>
                </div>
              ) 
              : (
                <>
                  <div className="section-title-accountInfo">
                    Primary Details
                  </div>
                  <div>
                    <div className="first-section-my-profile">
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <FaUser />
                          </div>
                          <input
                            type="hidden"
                            name="user_id"
                            id="user_id"
                            value="1244003"
                          />
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            name="firstname"
                            id="firstname"
                            disabled={disableEdit === ""}
                            placeholder="First Name"
                            value={formData.firstname}
                            onChange={handleChange}
                          />
                        </div>
                        <span className="error-text-accountInfo firstname-error-accountInfo"></span>
                      </div>
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <FaUser />
                          </div>
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            name="lastname"
                            id="lastname"
                            disabled={disableEdit === ""}
                            placeholder="Last Name"
                            value={formData.lastname}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <FaPhoneAlt />
                          </div>
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            id="phoneno"
                            name="phoneno"
                            disabled={disableEdit === ""}
                            placeholder="Phone Number"
                            value={formData.phoneno}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <FaBuilding />
                          </div>
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            id="company_name"
                            name="company_name"
                            disabled={disableEdit === ""}
                            placeholder="Company Name (if applicable)"
                            value={formData.company_name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <hr className="hr-bet-sec-accinfo" />
                    <div className="section-title-accountInfo">Address</div>

                    {/* Address */}
                    <div className="input-section-accountInfo">
                      <div className="input-group-accountInfo">
                        <div className="input-icon-accountInfo">
                          <IoMdHome />
                        </div>
                        <input
                          type="text"
                          className={
                            disableEdit === ""
                              ? "form-control-accountInfo-disable"
                              : "form-control-accountInfo"
                          }
                          id="address"
                          name="address"
                          disabled={disableEdit === ""}
                          placeholder="Address "
                          value={formData.address}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* City */}
                    <div className="second-section-my-profile">
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <FaCity />
                          </div>
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            id="city"
                            name="city"
                            disabled={disableEdit === ""}
                            placeholder="City"
                            value={formData.city}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* State */}
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <IoMdHome />
                          </div>
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            id="state"
                            name="state"
                            disabled={disableEdit === ""}
                            placeholder="State"
                            value={formData.state}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <FaLocationPin />
                          </div>
                          <input
                            type="number"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            id="zipcode"
                            name="zipcode"
                            disabled={disableEdit === ""}
                            placeholder="Zip Code"
                            value={formData.zipcode}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      {/* Zip Code */}
                      {/* <div className='input-section-accountInfo'>
                                        <div className='input-group-accountInfo'>
                                            <div className='input-icon-accountInfo'><FaLocationPin /></div>
                                            <input
                                                type='text'
                                                className={disableEdit ? "form-control-accountInfo-disable" : "form-control-accountInfo"}
                                                id='zipcode'
                                                name='zipcode'
                                                disabled={disableEdit}
                                                placeholder='Zip Code'
                                                value={formData.zipcode}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div> */}

                      {/* Country */}
                      <div className="input-section-accountInfo">
                        <div className="input-group-accountInfo">
                          <div className="input-icon-accountInfo">
                            <BiWorld />
                          </div>
                          <input
                            type="text"
                            className={
                              disableEdit === ""
                                ? "form-control-accountInfo-disable"
                                : "form-control-accountInfo"
                            }
                            id="country"
                            name="country"
                            disabled={disableEdit === ""}
                            placeholder="Country"
                            value={formData.country}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ai_button_cont">
                      {disableEdit === "add" ? (
                        <>
                          <button
                            className="button-section-accountInfo-new"
                            onClick={addUserProfileDetails}
                          >
                            Add Profile
                          </button>
                          <button
                            className="edit-button-accountInfo-new"
                            onClick={() => setDisableEdit("")}
                          >
                            Cancel
                          </button>
                        </>
                      ) : disableEdit === "edit" ? (
                        <>
                          <button
                            className="button-section-accountInfo-new"
                            onClick={updateUserProfileDetails}
                          >
                            Update Profile
                          </button>
                          <button
                            className="edit-button-accountInfo-new"
                            onClick={() => setDisableEdit("")}
                          >
                            Cancel
                          </button>
                        </>
                      ) : null}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default AccountInformation;
